import React from 'react';
import './AddModuleSkeleton.scss';

const AddModuleSkeleton = () => (
    <div className="add-module-skeleton">
        <div className="ams-form-fields">
            <div className="ams-row">
                <div className="ams-field">
                    <div className="ams-label" />
                    <div className="ams-input" />
                </div>
                <div className="ams-field">
                    <div className="ams-label" />
                    <div className="ams-input" />
                </div>
            </div>
            <div className="ams-row">
                <div className="ams-field">
                    <div className="ams-label" />
                    <div className="ams-select" />
                </div>
                <div className="ams-field">
                    <div className="ams-label" />
                    <div className="ams-select" />
                </div>
            </div>
            <div className="ams-row">
                <div className="ams-field ams-field--full">
                    <div className="ams-label" />
                    <div className="ams-multiselect" />
                </div>
            </div>
        </div>

        <div className="ams-filters">
            <div className="ams-filter-pill" />
            <div className="ams-filter-pill" />
            <div className="ams-select ams-filter-select" />
            <div className="ams-select ams-filter-select" />
            <div className="ams-searchbar" />
        </div>

        <div className="ams-table">
            <div className="ams-table-header">
                {[...Array(5)].map((_, i) => (
                    <div key={i} className="ams-th" />
                ))}
            </div>
            {[...Array(5)].map((_, i) => (
                <div key={i} className="ams-table-row">
                    <div className="ams-td ams-td--checkbox" />
                    <div className="ams-td ams-td--thumb" />
                    <div className="ams-td ams-td--title" />
                    <div className="ams-td ams-td--desc" />
                    <div className="ams-td ams-td--type" />
                </div>
            ))}
        </div>
    </div>
);

export default AddModuleSkeleton;
